import React from 'react';
import logoHorizontal from '../assets/athena/logo-horizontal.png';
import symbolIcon     from '../assets/athena/symbol-icon.png';
import logoVertical   from '../assets/athena/logo-vertical.png';
import logoDark       from '../assets/athena/logo-dark.png';

/**
 * Logo oficial Athena — usa imagens reais da marca.
 *
 * showText=true  → versão horizontal (símbolo + ATHENA lado a lado)
 *                  uso: header, topbar, sidebar
 * showText=false → símbolo isolado (ícone circular escuro)
 *                  uso: mini-avatar, ícones compactos
 *
 * variant='vertical' → versão vertical completa (splash, onboarding)
 * variant='dark'     → versão dark com fundo embutido (PWA, contexts escuros)
 */
export const AthenaLogo = React.memo(function AthenaLogo({
  size     = 36,
  showText = true,
  style    = {},
  variant  = 'auto',
}) {
  // Símbolo isolado — logo-horizontal.png tem ratio 4.25:1 (429×101 cropped)
  // symbol-icon.png é ≈1:1 (263×264 cropped)
  if (!showText || variant === 'symbol') {
    return (
      <img
        src={symbolIcon}
        alt="Athena"
        draggable={false}
        style={{
          width:      size,
          height:     size,
          objectFit: 'contain',
          flexShrink: 0,
          display:   'block',
          ...style,
        }}
      />
    );
  }

  if (variant === 'vertical') {
    return (
      <img
        src={logoVertical}
        alt="Athena"
        draggable={false}
        style={{
          width:      size,
          height:    'auto',
          objectFit: 'contain',
          flexShrink: 0,
          display:   'block',
          ...style,
        }}
      />
    );
  }

  if (variant === 'dark') {
    return (
      <img
        src={logoDark}
        alt="Athena"
        draggable={false}
        style={{
          width:      size,
          height:     size,
          objectFit: 'contain',
          flexShrink: 0,
          display:   'block',
          ...style,
        }}
      />
    );
  }

  // Padrão showText=true → versão horizontal
  // ratio natural: 429×101 ≈ 4.25:1
  // altura = size, largura = size × 4.25 (browser calcula automaticamente)
  return (
    <img
      src={logoHorizontal}
      alt="Athena"
      draggable={false}
      style={{
        height:    size,
        width:    'auto',
        objectFit: 'contain',
        flexShrink: 0,
        display:  'block',
        ...style,
      }}
    />
  );
});
